module.exports = __webpack_public_path__ + "img/Elephants_Trunk_Nebula.0a043842.jpg";